import React from "react";

const GameInfo = React.createContext();

export default GameInfo;
